jQuery(document).ready(function($) {
	jQuery('.has_hidden p a').on('click', function(e){
		e.preventDefault();
		jQuery('.has_hidden em').slideToggle();
		jQuery('.has_hidden em').toggleClass('show');
		if(jQuery('.has_hidden p a').hasClass('active')){
			jQuery('.has_hidden p a').text('Read Full Story');
			jQuery('.has_hidden p a').removeClass('active');
		}
		else{
			jQuery('.has_hidden p a').text('Hide Full Story');
			jQuery('.has_hidden p a').addClass('active');
		}
	});

    jQuery('.cru-2-col').each(function(){
        parentHeight = jQuery(this).height();
        jQuery(this).children('.image-column').height(parentHeight);
    });

    jQuery('a.scroll_to').on('click', function(e){
		e.preventDefault();
		jQuery('a.scroll_to').each(function(){
			jQuery(this).removeClass('active');
		});
		jQuery(this).addClass('active');
		var targ = jQuery(this).attr('href');
		if(targ == "#our-story" && jQuery(window).width() <= 782){
			targ = "#terrior_mobile";
		}
		if(jQuery(window).width() > 900){
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
		else{
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
	});

	jQuery('.smooth_scroll a').on('click', function(e){
		e.preventDefault();
		var targ = jQuery(this).attr('href');
		jQuery('html, body').animate({
			scrollTop: jQuery(targ).offset().top
		}, 1000);
	});

	jQuery('.image-column .slider').slick({
	    infinite: true,
	    dots: true,
	    speed: 500,
	    fade: true,
	    cssEase: 'linear',
	    autoplay: true,
  		autoplaySpeed: 5000,
  		prevArrow:"<i class='fa-solid fa-chevron-left'></i>",
      	nextArrow:"<i class='fa-solid fa-chevron-right'></i>"
	});

	var product_item_height = 0;
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		if(jQuery(this).height() > product_item_height){
			product_item_height = jQuery(this).height();
		}
	});
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		jQuery(this).height(product_item_height);
	});

	if(jQuery(window).width() <= 781){
		jQuery('.cru-featured-products').slick({
			infinite: true,
			dots: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: false
		});

		jQuery('.layout-grid .cru-product-slider').slick({
			infinite: true,
			dots: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: false
		});
	}

	jQuery('a.open_submenu').on('click', function(e){
		e.preventDefault();
		console.log('test');
		jQuery(this).siblings('ul.sub-menu').html();
		if(jQuery(this).hasClass('active')){
			jQuery(this).parent().removeClass('active');
			jQuery(this).removeClass('active');
		}
		else{
			jQuery(this).parent().addClass('active');
			jQuery(this).addClass('active');
		}
	});

	// jQuery('.cta-block a.btn').on('click', function(e){
	// 	e.preventDefault();
	// 	if(!jQuery(this).siblings('.cta-overlay').hasClass('active')){
	// 		jQuery('.cta-overlay.active').each(function(){
	// 			jQuery(this).removeClass('active');
	// 			jQuery(this).slideToggle();
	// 		});
	// 		jQuery(this).siblings('.cta-overlay').addClass('active');
	// 		jQuery(this).siblings('.cta-overlay').slideToggle();
	// 	}
	// 	else{
	// 		jQuery(this).siblings('.cta-overlay').removeClass('active');
	// 		jQuery(this).siblings('.cta-overlay').slideToggle();
	// 	}
	// });

	jQuery('a.accordion_link').on('click', function(e){
		e.preventDefault();
		var targ = jQuery(this).attr('targets');
		jQuery('#'+targ).slideToggle();
	});
});


jQuery(document).ready(function(){
	jQuery('.product_reviews .metafield-rich_text_field').slick({
	    infinite: true,
	    dots: true,
	    speed: 500,
	    fade: true,
	    cssEase: 'linear',
	    autoplay: true,
  		autoplaySpeed: 10000,
	});
	setTimeout(function(){
		var heights = jQuery('.product_reviews .metafield-rich_text_field #slick-slide00').height();
		jQuery('.product_reviews .metafield-rich_text_field .slick-list').height(heights);
	}, 300);
	jQuery('.product_reviews .metafield-rich_text_field').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	    var heights = jQuery('#slick-slide0'+nextSlide).height();
	    jQuery('.product_reviews .metafield-rich_text_field .slick-list').height(heights);
	});
	jQuery('figure.wp-block-image').each(function(){
		var img_ht = jQuery(this).children('img').height();
		jQuery(this).height(img_ht);
	});
	jQuery('figure.wp-block-image').each(function(){
		var img_ht = jQuery(this).find('img').height();
		jQuery(this).height(img_ht);
	});
});